import * as yup from 'yup';
import { TableFormData, TableStatus } from '../../types';
import i18next from 'i18next';

export const tableValidationSchema = () =>
  yup.object().shape({
    tableNumber: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .typeError(i18next.t('validation.table.number.type'))
      .required(i18next.t('validation.table.number.required'))
      .min(1, i18next.t('validation.table.number.min'))
      .integer(i18next.t('validation.table.number.integer')),
    capacity: yup
      .number()
      .transform((value) => (isNaN(value) || value === 0 ? null : value))
      .nullable(),
    status: yup
      .number()
      .oneOf([
        TableStatus.Available,
        TableStatus.Occupied,
        TableStatus.Reserved,
      ])
      .required(i18next.t('validation.table.status.required')),
    notes: yup
      .string()
      .transform((value) => (!value ? null : value))
      .nullable(),
  }) as yup.ObjectSchema<TableFormData>;
